import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "views",
  "use": "views-usage",
  "viewBox": "0 0 14 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 11\" id=\"views\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 1.75C0 1.06.56.5 1.25.5h4c.69 0 1.25.56 1.25 1.25v2.5c0 .69-.56 1.25-1.25 1.25h-4C.56 5.5 0 4.94 0 4.25v-2.5Zm8 1c0-.69.56-1.25 1.25-1.25h3.5c.69 0 1.25.56 1.25 1.25v5.5c0 .69-.56 1.25-1.25 1.25h-3.5C8.56 9.5 8 8.94 8 8.25v-5.5Zm-7 5c0-.69.56-1.25 1.25-1.25h3.5C6.44 6.5 7 7.06 7 7.75v1.5c0 .69-.56 1.25-1.25 1.25h-3.5C1.56 10.5 1 9.94 1 9.25v-1.5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol